import { FILTER_MESSAGES, FiltersMessages } from "../inputs/filters.messages";

export type NotificationsFiltersMessages = FiltersMessages & {
  readOption: string;
  dateTimeOption: string;
  detailsOption: string;
  yesOption: string;
  noOption: string;
};

export const NOTIFICATIONS_FILTER_MESSAGES: NotificationsFiltersMessages = {
  ...FILTER_MESSAGES,
  readOption: "Lida",
  dateTimeOption: "Data",
  detailsOption: "Detalhes",
  yesOption: "Sim",
  noOption: "Não",
};

export default NOTIFICATIONS_FILTER_MESSAGES;
